import * as React from 'react';
import { Action } from 'redux';
import { AppState, history } from 'src';
import { AppDispatcher, OptionsViewModel } from '@models/common.models';
import { requestAction } from '@common/components/common.actions';
import { contractService } from '@services/ContractService';
import { ContractCheckPaymentViewModel } from '@models/Payment';
import { ContractBalancesViewModel } from '@models/Contract';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { ToastComponent, ToastType, ToastOptions } from '@common/components';
import { toast } from 'react-toastify';

export enum ContractBalancesActionType {
  SetPaymentSources = 'SetPaymentSources',
  SetContractBalances = 'SetContractBalances',
  SelectBalance = 'SelectBalance',
  ClearBalances = 'ClearBalances'
}

export interface SetPaymentSourcesAction extends Action {
  readonly type: ContractBalancesActionType.SetPaymentSources;
  readonly paymentSources: OptionsViewModel[];
}
export function setPaymentSources(list: OptionsViewModel[]): SetPaymentSourcesAction {
  return {
    type: ContractBalancesActionType.SetPaymentSources,
    paymentSources: list
  };
}
export function getPaymentSources() {
  return async (dispatch: AppDispatcher) => {
    return dispatch(
      requestAction(() => contractService.getPaymentSources(), setPaymentSources, {
        overrideFailMessage: 'Unable to load payment sources.'
      })
    );
  };
}

export interface SetContractBalancesAction extends Action {
  readonly type: ContractBalancesActionType.SetContractBalances;
  readonly balances: ContractBalancesViewModel[];
}
export function setContractBalances(list: ContractBalancesViewModel[]): SetContractBalancesAction {
  return {
    type: ContractBalancesActionType.SetContractBalances,
    balances: list
  };
}
export function getContractBalances(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(() => contractService.getContractBalances(contractId), setContractBalances, {
        overrideFailMessage: 'Unable to load contract balances.'
      })
    );
  };
}

export interface SelectBalanceAction extends Action {
  readonly type: ContractBalancesActionType.SelectBalance;
  readonly balance: ContractBalancesViewModel;
}
export function selectBalance(balance: ContractBalancesViewModel): SelectBalanceAction {
  return {
    type: ContractBalancesActionType.SelectBalance,
    balance: balance
  };
}

export function saveContractCheckPayment(contractCheckPayment: ContractCheckPaymentViewModel) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(
        () => contractService.saveCheckPayment(contractCheckPayment),
        () => {
          return { type: '' };
        },
        {
          hasToast: true,
          toastSuccessMessage: 'Contract Check Payment Saved Successfully.',
          overrideFailMessage: 'Unable to save check payment.',
          includeErrorDetail: true
        }
      )
    );
  };
}

export interface ClearBalancesAction extends Action {
  readonly type: ContractBalancesActionType.ClearBalances;
}
export function clearBalances(): ClearBalancesAction {
  return {
    type: ContractBalancesActionType.ClearBalances
  };
}

export function redirectToContract(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    toast.success(
      <ToastComponent type={ToastType.Success} message={`Payment(s) applied to contract successfully.`} />,
      ToastOptions.Success
    );
    history.push(getRoute(RouteDefinitions.contract.Details, { id: +contractId }));
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-balances/contract-balances.actions.tsx